module.exports = __webpack_public_path__ + "static/media/img-emandamento-sansiro-03.639293b6.jpg";